import { Mail, MapPin, Phone, ExternalLink } from "lucide-react";
import PageHeader from "../components/PageHeader";
import ContactForm from "../components/ContactForm";
import SEO from "../components/SEO";
import BookMyTutorPromo from "../components/BookMyTutorPromo";
import { HEAD_OFFICE, BRANCHES, CITIES } from "../data/siteData";

export default function Contact() {
    return (
        <div data-testid="contact-page">
            <SEO
                title="Contact Anand Tutorials — Jabalpur · Bhopal · Nagpur"
                description="Reach Anand Tutorials head office and city branches. Phone, email, address, contact form. Quick response within 30 minutes during business hours."
                keywords="contact Anand Tutorials, home tuition contact, Jabalpur tuition contact, Bhopal tuition contact, Nagpur tuition contact"
                path="/contact"
            />
            <PageHeader
                eyebrow="Get in Touch"
                title="Contact Anand Tutorials"
                subtitle="We respond within 30 minutes during business hours. Call us, email us, or fill the form — whatever's fastest for you."
            />

            <section className="py-16 bg-white">
                <div className="max-w-7xl mx-auto px-6 lg:px-8 grid lg:grid-cols-2 gap-12">
                    <div>
                        <div className="text-xs font-semibold uppercase tracking-[0.3em] text-[#3B82F6] mb-3">Head Office</div>
                        <h2 className="font-heading text-3xl sm:text-4xl font-bold mb-6">Talk to our team.</h2>
                        <div className="space-y-4 text-slate-700" data-testid="head-office-contact-card">
                            <div className="flex gap-3"><MapPin className="w-5 h-5 mt-1 text-[#1E3A8A] shrink-0" /><div><strong>Head Office:</strong> {HEAD_OFFICE.address}</div></div>
                            {HEAD_OFFICE.phones.map((p, i) => (
                                <div key={p} className="flex gap-3"><Phone className="w-5 h-5 mt-1 text-[#1E3A8A] shrink-0" /><a className="hover:text-[#1E3A8A]" href={`tel:${p.replace(/\s+/g, "")}`} data-phone-key="headoffice">Call Head Office{HEAD_OFFICE.phones.length > 1 ? ` · Line ${i + 1}` : ""}</a></div>
                            ))}
                            <div className="flex gap-3"><Mail className="w-5 h-5 mt-1 text-[#1E3A8A] shrink-0" /><div className="flex flex-col gap-1"><a className="hover:text-[#1E3A8A] break-all" href={`mailto:${HEAD_OFFICE.email}`} data-testid="contact-email-primary">{HEAD_OFFICE.email}</a><a className="hover:text-[#1E3A8A] break-all" href="mailto:info@anandtutorials.com" data-testid="contact-email-business">info@anandtutorials.com</a></div></div>
                            <div className="pt-2">
                                <a
                                    href={HEAD_OFFICE.mapUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-testid="head-office-get-directions"
                                    className="inline-flex items-center gap-2 bg-[#1E3A8A] text-white font-semibold px-4 py-2.5 rounded-lg hover:bg-[#1E40AF] transition-colors text-sm"
                                >
                                    <MapPin className="w-4 h-4" /> Get Directions on Google Maps <ExternalLink className="w-3.5 h-3.5" />
                                </a>
                            </div>
                        </div>

                        {/* Head Office map embed */}
                        <div className="mt-6 rounded-2xl overflow-hidden border border-slate-200 shadow-sm" data-testid="head-office-map-embed">
                            <iframe
                                title="Anand Tutorials Head Office — Ghadi Chowk, Vijay Nagar, Jabalpur"
                                src={HEAD_OFFICE.mapEmbed}
                                width="100%"
                                height="280"
                                style={{ border: 0 }}
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                                allowFullScreen
                            />
                        </div>

                        <div className="mt-8">
                            <h3 className="font-heading font-semibold mb-3 text-[#0F172A]">City Branches</h3>
                            <div className="space-y-3">
                                {Object.values(CITIES).map((c) => (
                                    <div key={c.slug} className="bg-[#F8FAFC] border border-slate-200 rounded-xl p-4">
                                        <div className="font-heading font-semibold text-[#1E3A8A]">{c.name}</div>
                                        <div className="text-sm text-slate-600 mt-1">{c.address}</div>
                                        <a className="text-sm text-[#1E3A8A] font-semibold mt-1 inline-block" href={`tel:${c.phoneRaw}`} data-phone-key={c.slug}>Call {c.name} Team</a>
                                    </div>
                                ))}
                                {BRANCHES.map((b) => (
                                    <div key={b.label} className="bg-[#F8FAFC] border border-slate-200 rounded-xl p-4">
                                        <div className="font-heading font-semibold text-[#1E3A8A]">{b.label}</div>
                                        <div className="text-sm text-slate-600 mt-1">{b.address}</div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div>
                        <ContactForm />
                    </div>
                </div>
            </section>
            <BookMyTutorPromo />
        </div>
    );
}
